let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lVTe9")).then(() => parcelRequire('bw5U3'));